module.exports = __webpack_public_path__ + "static/media/heroImageLogo.854f413d.png";